import type {
	AnimationOptions,
	AnimationsBehavior,
	VariantDataItem,
	NamedEffect,
	TimeAnimationOptions,
	AnimationDef,
	ScrubAnimationOptions,
} from '@wix/thunderbolt-becky-types'

export type ConvertEffectToAnimationDef = (animation: TimeAnimationOptions) => Partial<AnimationDef>
export type TransformBgScrubToEffectsMap = (compIdToBgScrubs: {
	[compId: string]: Array<AnimationsBehavior>
}) => {
	[compId: string]: {
		[effectId: string]: Array<{ animation: AnimationOptions; variants: Array<VariantDataItem> }>
	}
}

export const convertEffectToAnimationDef: ConvertEffectToAnimationDef = (animation) => {
	const effect = animation.namedEffect || animation.keyframeEffect || ({} as NamedEffect)
	const propertiesToOmit = ['id', 'type']

	return {
		name: effect.type,
		duration: animation.duration ? animation.duration / 1000 : 0,
		delay: animation.delay ? animation.delay / 1000 : 0,
		params: Object.fromEntries(Object.entries(effect).filter(([key]) => !propertiesToOmit.includes(key))),
		iterations: animation.iterations,
		fill: animation.fill,
		alternate: animation.alternate,
		easing: animation.easing,
	}
}

function transformBgScrubToAnimationOptions(bgScrub: AnimationsBehavior): ScrubAnimationOptions {
	const { name, params = {} } = bgScrub

	let type = name
	if (name === 'BgFadeIn' || name === 'BgFadeOut') {
		type = 'BgFade'
		params.range = name.endsWith('In') ? 'in' : 'out'
	} else if (name === 'BgZoomIn' || name === 'BgZoomOut') {
		type = 'BgZoom'
		params.direction = name.endsWith('In') ? 'in' : 'out'
	} else if (name === 'BgPanLeft' || name === 'BgPanRight') {
		type = 'BgPan'
		params.direction = name.endsWith('Left') ? 'left' : 'right'
	}

	return {
		type: 'ScrubAnimationOptions',
		namedEffect: {
			// @ts-ignore
			type,
			...params,
		},
		delay: 0,
		duration: 1000,
		fill: 'both',
		iterations: 1,
	}
}

// @ts-ignore
export const transformBgScrubToEffectsMap: TransformBgScrubToEffectsMap = (compIdToBgScrubs) => {
	return Object.fromEntries(
		Object.entries(compIdToBgScrubs).map(([compId, bgScrubs]) => [
			compId,
			Object.fromEntries(
				bgScrubs.map((bgScrub) => [
					bgScrub.behaviorId,
					[
						{
							animation: transformBgScrubToAnimationOptions(bgScrub),
							variants:
								bgScrub.viewMode === 'MOBILE'
									? [
											{
												type: 'Mobile',
											},
									  ]
									: ([] as Array<VariantDataItem>),
						},
					],
				])
			),
		])
	)
}
